import { datadogRum } from '@datadog/browser-rum';
import { refreshAccessToken } from '../../api';
import { AccessToken } from '../access-token';
import { isTokenExpired } from '../access-token/utils';
import TokenExpiredError from '../access-token/TokenExpiredError';
import EventBus from '../event-bus';
import { EVENT_BUS_EVENT } from '../event-bus/enums/event-bus-events';
import { currentSSOService } from '../sso-auth-service/CurrentSSOService';
import { UserImpersonation } from '../user-impersonation';

const EXP_DELTA = 60;
export default class RefreshTokenService {
  private static activePromise: Promise<any> | null;

  //eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() { }

  public static checkTokens() {
    if (!RefreshTokenService.activePromise) {
      RefreshTokenService.activePromise = new Promise<void>(
        (resolve, reject) => {
          const accessToken = AccessToken.getToken();
          const isAccessExpired = isTokenExpired(accessToken, EXP_DELTA);
          if (!accessToken || !isAccessExpired) resolve();
          else {
            const refreshToken = AccessToken.getRefreshToken();

            const onError = (e: any) => {
              const eventBus = EventBus.getInstance();
              AccessToken.clearTokens();
              UserImpersonation.clearImpersonationData();
              eventBus.dispatch(EVENT_BUS_EVENT.LOGOUT);
              datadogRum.addError(e);
              reject(e);
            };

            if (refreshToken) {
              const ssoService = currentSSOService.getSSOService();
              if (!ssoService) {
                refreshAccessToken().then(
                  () => resolve(),
                  onError
                );
              } else {
                ssoService.getRefreshTokenApiCall();
                const apiCall = ssoService.getRefreshTokenApiCall();
                apiCall({ params: undefined }).then(
                  () => resolve(),
                  onError
                );
              }
            } else {
              reject(new TokenExpiredError());
              AccessToken.clearTokens();
              UserImpersonation.clearImpersonationData();
            }
          }
        }
      );
      RefreshTokenService.activePromise
        .then(() => (RefreshTokenService.activePromise = null))
        .catch(() => (RefreshTokenService.activePromise = null));
    }
    return RefreshTokenService.activePromise;
  }
}
